export class DocumentBundlesApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getDocumentBundles({ signal, ...params }) {
    return this.#http.get('/api/document-bundles', {
      params,
      paramsSerializer: { indexes: null },
      signal,
    });
  }

  async createDocumentBundle(body) {
    return this.#http.post('/api/document-bundles', body);
  }

  async editDocumentBundle(body) {
    return this.#http.put(`/api/document-bundles/${body.documentBundleId}/v2`, body);
  }

  async deleteDocumentBundle({ id }) {
    return this.#http.delete(`/api/document-bundles/${id}`);
  }

  async reorderDocumentBundleTypes(body) {
    return this.#http.put(`/api/document-bundles/${body.documentBundleId}/v2`, body);
  }

  async addDocumentBundleType(body) {
    return this.#http.put(`/api/document-bundles/${body.documentBundleId}/v2`, body);
  }

  async editDocumentBundleType(body) {
    return this.#http.put(`/api/document-bundles/${body.documentBundleId}/v2`, body);
  }

  async deleteDocumentBundleType(body) {
    return this.#http.put(`/api/document-bundles/${body.documentBundleId}/v2`, body);
  }
}
